var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileInsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8148 3.59961H6.8166C5.04968 3.59961 3.61731 5.03198 3.61731 6.7989V14.7971C3.61731 16.5641 5.04968 17.9964 6.8166 17.9964H14.8148C16.5818 17.9964 18.0141 16.5641 18.0141 14.7971V6.7989C18.0141 5.03198 16.5818 3.59961 14.8148 3.59961ZM15.2147 7.19843C15.6565 7.19843 16.0146 6.84035 16.0146 6.39861C16.0146 5.95687 15.6565 5.59879 15.2147 5.59879C14.773 5.59879 14.4149 5.95687 14.4149 6.39861C14.4149 6.84035 14.773 7.19843 15.2147 7.19843ZM10.8157 7.19852C8.8279 7.19852 7.21649 8.80993 7.21649 10.7977C7.21649 12.7855 8.8279 14.3969 10.8157 14.3969C12.8035 14.3969 14.4149 12.7855 14.4149 10.7977C14.4149 8.80993 12.8035 7.19852 10.8157 7.19852ZM8.01632 10.7977C8.01632 9.25166 9.26963 7.99834 10.8157 7.99834C12.3618 7.99834 13.6151 9.25166 13.6151 10.7977C13.6151 12.3438 12.3618 13.5971 10.8157 13.5971C9.26963 13.5971 8.01632 12.3438 8.01632 10.7977Z",
    fill: "#A99CEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileInsIcon);
export default __webpack_public_path__ + "static/media/mobile-ins-icon.68602b22140d216113f73dee9c451ffa.svg";
export { ForwardRef as ReactComponent };